






























































































import { Component, Vue } from 'vue-property-decorator';
import { workspacesApi } from '@/workspaces/workspaces';
import { RegisterUserViewModel } from '@/workspaces/models/request/registerUserViewModel';
import authService from '@/authentication/authentication.service';
import { validationMixin } from 'vuelidate';
import { minLength, required, sameAs, maxLength } from 'vuelidate/lib/validators';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import jwt_decode from 'jwt-decode';
import { InviteToken } from '@/features/registration/models/inviteToken';

const containsLetters = (value: string) => /(.*[a-z].*)/.test(value) && /(.*[A-Z].*)/.test(value);
const containsNumbers = (value: string) => /\d/.test(value);

@Component({
	components: {
		LoadingSpinner
	},
	mixins: [validationMixin],
	validations: {
		firstName: {
			required,
			maxLength: maxLength(64)
		},
		lastName: {
			required,
			maxLength: maxLength(64)
		},
		password: {
			required,
			minLength: minLength(8),
			containsLetters,
			containsNumbers
		},
		confirmPassword: {
			required,
			sameAs: sameAs('password')
		}

	}
})
export default class Register extends Vue {

	public email: string = '';
	public firstName: string = '';
	public lastName: string = '';
	public password: string = '';
	public confirmPassword: string = '';

	public loading: boolean = true;
	public isTokenValid: boolean = false;
	public tokenErrorMsg: string = '';

	public token: string = '';

	public async created(): Promise<void> {
		this.token = this.$route.params.token;
		const validateResponse = await workspacesApi.validateRegistrationToken(this.token);
		this.loading = false;
		if (validateResponse.isValid) {
			this.isTokenValid = true;
			this.tokenErrorMsg = '';
			this.email = validateResponse.email;
		} else {
			this.isTokenValid = false;
			this.tokenErrorMsg = validateResponse.errorMsg;
		}
	}

	public async register(): Promise<void> {
		const user: RegisterUserViewModel = {
			email: this.email,
			firstName: this.firstName,
			lastName: this.lastName,
			password: this.password,
			tokenString: this.token
		};
		try {
			await workspacesApi.registerUser(user);
			const token: InviteToken = jwt_decode(user.tokenString);
			if (token.loginUrl) {
				window.location.assign(token.loginUrl);
			} else {
				authService.login();
			}
		} catch (err: any) {
			this.tokenErrorMsg = err.message;
		}
	}
}
